<template lang="html">
  <div class="si-input-radio">
    <div
      v-if="internalLabel"
      style="margin-bottom:-8px"
    >
      <v-label>{{ internalLabel }}</v-label>
    </div>

    <v-radio-group
      ref="input"
      v-model="internalValue"
      v-bind="$attrs"
      :label="undefined"
      :rules="internalRules"
      persistent-hint
      v-on="$listeners"
    >
      <v-radio
        v-for="(item, i) in $attrs.items"
        :key="i"
        :label="itemValue(item).text"
        :value="itemValue(item).value"
      />
    </v-radio-group>
  </div>
</template>

<script>
import helpers from '@/mixins/helpers'
import element from '@/mixins/element'

export default {
  mixins: [ helpers, element ],
  props: {
    value: [ String, Boolean ]
  },
  data () {
    return {
      lazyValue: this.value,
      requiredRule: v => this.valueValid(v) || `${this.$attrs.label || 'This field'} is required`
    }
  },
  computed: {
    internalValue: {
      get () {
        return this.lazyValue
      },
      set (val) {
        this.lazyValue = val
        this.$emit('input', val)
      }
    }
  },
  watch: {
    value (val) {
      this.lazyValue = val
    }
  },
  methods: {
    itemValue (item) {
      if (typeof item === 'string') {
        return { text: item || '', value: item || '' }
      } else {
        return item
      }
    }
  }
}
</script>

<style lang="css">
  .si-input-radio .v-messages {
    margin-bottom: 8px;
  }
</style>
